import { Box, CircularProgress, Stack, Typography } from "@mui/material";

import { ShipperShipmentQA } from "./components/ShipperShipmentQA";

interface Props {
  error: string | null;
  loading: boolean;
  qaList: ShipmentQA[];
  shipment: CondensedShipment | undefined;
}

export function ShipperShipmentQATab(props: Props) {
  const { error, loading, qaList, shipment } = props;

  if (loading || shipment === undefined) {
    return (
      <Stack alignItems="center" sx={{ mt: "1rem" }}>
        <CircularProgress />
      </Stack>
    );
  }
  if (error != null) {
    return (
      <Stack>
        <Typography color="red" align="center">
          {error}
        </Typography>
      </Stack>
    );
  }

  if (!qaList || qaList.length < 1) {
    return (
      <Stack>
        <Typography mt=".5rem" align="center">
          No questions have been asked for this shipment.
        </Typography>
      </Stack>
    );
  }

  return (
    <Stack direction="column" justifyContent="space-between">
      <Box>
        {qaList.map((shipmentQA) => (
          <Box key={shipmentQA.question.id}>
            <ShipperShipmentQA shipmentQA={shipmentQA} />
          </Box>
        ))}
      </Box>
    </Stack>
  );
}
